<mat-sidenav-container [class.side-sheet-open]="leftSideOpen() || rightSideOpen()">
  <mat-sidenav [autoFocus]="leftSideAutoFocusTarget()" [style.width]="leftSideWidth()" [mode]="leftSideMode()" [opened]="leftSideOpen()" (openedChange)="leftSideOpen.set($event)">
    @if (!isServerPlatform) {
      <ng-container #leftSideContent></ng-container>
    }
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
  <mat-sidenav [autoFocus]="rightSideAutoFocusTarget()" [style.width]="rightSideWidth()" [mode]="rightSideMode()" [opened]="rightSideOpen()" (openedChange)="rightSideOpen.set($event)" position="end">
    @if (!isServerPlatform) {
      <ng-container #rightSideContent></ng-container>
    }
  </mat-sidenav>
</mat-sidenav-container>
